import React, { useRef } from 'react'
import styled, { css, createGlobalStyle } from 'styled-components'
import { Portal  } from 'react-portal';
import Close from '../Close';
import { useTransition, animated } from 'react-spring';
import { easePoly } from 'd3-ease';
import { RolesEnum, useUserStore } from '@/stores/userStore';
import useOnClickOutside from '@/hooks/useOnClickOutside';

type ModalProps = {
  isOpen: boolean
  onClose: () => void
  close?: boolean
  maxWidth?: number
}

export const AdminModal: React.FC<ModalProps> = ({ children, ...otherProps }) => {
  const { role } = useUserStore()

  if (role !== RolesEnum.Admin) return null

  return (
    <Modal
     {...otherProps}
    >
      {children}
    </Modal>
  )
}

const Modal: React.FC<ModalProps> = ({ isOpen, onClose, children, maxWidth, close = false }) => {
  const ref = useRef<any>(null)

  useOnClickOutside(ref, onClose)

  const handleClose = (e) => {
    if (!ref.current || ref.current.contains(e.target)) {
      return;
    }

    onClose()
  }

  const backdropTransitions = useTransition(isOpen, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    config: {
      duration: 100,
      easing: easePoly.exponent(2),
    },
  })

  const modalTransitions = useTransition(isOpen, {
    from: { opacity: 0, scale: 0.9 },
    enter: { opacity: 1, scale: 1 },
    leave: { opacity: 0, scale: 0.9 },
    config: {
      duration: 300,
      easing: easePoly.exponent(2),
    },
  })

  return (
    <Portal node={document && document.getElementById('modals')}>
      {backdropTransitions((styles, item) => item ? (
        <Backdrop
          style={styles}
          // onClick={handleClose}
        >
          {modalTransitions((modalStyles, modal) => modal ? (
            <Content style={modalStyles} ref={ref} $maxWidth={maxWidth}>
              {close && <ModalClose color="#000" onClick={onClose} />}
              {children}
            </Content>
          ) : '')}
        </Backdrop>
      ) : '')}
      <ScrollDisabler />
    </Portal  >
  )
}

export default Modal

const Title = styled.div`
  font-weight: 500;
  font-size: 2.4rem;
  line-height: 2.4rem;
  color: #000000;
`
const Body = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 80vh;
`
// @ts-ignore
Modal.Title = Title 
// @ts-ignore
Modal.Body = Body



const ScrollDisabler = createGlobalStyle`
  body {
    overflow-y: hidden;
  }
`

const ModalClose = styled(Close)`
  position: absolute;
  top: 16px;
  right: 16px;
`

const Backdrop = styled(animated.div)`
  width: 100vw;
  height: 100vh;
  background-color:rgba(0, 0, 0, 0.5);

  position: fixed;
  top: 0;
  left: 0;
  z-index: 10001;

  display: flex;
  justify-content: center;
  align-items: center;
`

const Content = styled(animated.div)<{ $maxWidth?: number }>`
  background: #FFFFFF;
  max-width: 991px;
  width: 100%;
  padding: 20px;
  position: relative;
  max-height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
  z-index: 20001;

  ${({ $maxWidth }) => $maxWidth && css`
    max-width: ${$maxWidth}px;
  `}
`